export const FETCH_ORDERSFROMCHEMIST_INIT_ACTION =
  "FETCH_ORDERSFROMCHEMIST_INIT_ACTION";
export const FETCH_ORDERSFROMCHEMIST_SUCCESS_ACTION =
  FETCH_ORDERSFROMCHEMIST_INIT_ACTION + "_SUCCESS";
export const FETCH_ORDERSFROMCHEMIST_FAIL_ACTION =
  FETCH_ORDERSFROMCHEMIST_INIT_ACTION + "_ERROR";

export const FETCH_NORMALPROCESSEDORDERS_INIT_ACTION =
  "FETCH_NORMALPROCESSEDORDERS_INIT_ACTION";
export const FETCH_NORMALPROCESSEDORDERS_SUCCESS_ACTION =
  FETCH_NORMALPROCESSEDORDERS_INIT_ACTION + "_SUCCESS";
export const FETCH_NORMALPROCESSEDORDERS_FAIL_ACTION =
  FETCH_NORMALPROCESSEDORDERS_INIT_ACTION + "_FAIL";

export const FETCH_DELIVEREDNORMALORDERS_INIT_ACTION =
  "FETCH_DELIVEREDNORMALORDERS_INIT_ACTION";
export const FETCH_DELIVEREDNORMALORDERS_SUCCESS_ACTION =
  FETCH_DELIVEREDNORMALORDERS_INIT_ACTION + "_SUCCESS";
export const FETCH_DELIVEREDNORMALORDERS_FAIL_ACTION =
  FETCH_DELIVEREDNORMALORDERS_INIT_ACTION + "_FAIL";

export const FETCH_URGENT_ORDERS_INIT_ACTION =
  "FETCH_URGENT_ORDERS_INIT_ACTION";
export const FETCH_URGENT_ORDERS_SUCCESS_ACTION =
  FETCH_URGENT_ORDERS_INIT_ACTION + "_SUCCESS";
export const FETCH_URGENT_ORDERS_FAIL_ACTION =
  FETCH_URGENT_ORDERS_INIT_ACTION + "_FAIL";

export const FETCH_PROCESSEDURGENTORDERS_INIT_ACTION =
  "FETCH_PROCESSEDURGENTORDERS_INIT_ACTION";
export const FETCH_PROCESSEDURGENTORDERS_SUCCESS_ACTION =
  FETCH_PROCESSEDURGENTORDERS_INIT_ACTION + "_SUCCESS";
export const FETCH_PROCESSEDURGENTORDERS_FAIL_ACTION =
  FETCH_PROCESSEDURGENTORDERS_INIT_ACTION + "_FAIL";

export const FETCH_DELIVEREDURGENTORDERS_INIT_ACTION =
  "FETCH_DELIVEREDURGENTORDERS_INIT_ACTION";
export const FETCH_DELIVEREDURGENTORDERS_SUCCESS_ACTION =
  FETCH_DELIVEREDURGENTORDERS_INIT_ACTION + "_SUCCESS";
export const FETCH_DELIVEREDURGENTORDERS_FAIL_ACTION =
  FETCH_DELIVEREDURGENTORDERS_INIT_ACTION + "_FAIL";

export const FETCH_RETURNS_INIT_ACTION = "FETCH_RETURNS_INIT_ACTION";
export const FETCH_RETURNS_SUCCESS_ACTION =
  FETCH_RETURNS_INIT_ACTION + "_SUCCESS";
export const FETCH_RETURNS_FAIL_ACTION = FETCH_RETURNS_INIT_ACTION + "_FAIL";

export const FETCH_CREDITNOTES_INIT_ACTION = "FETCH_CREDITNOTES_INIT_ACTION";
export const FETCH_CREDITNOTES_SUCCESS_ACTION =
  FETCH_CREDITNOTES_INIT_ACTION + "_SUCCESS";
export const FETCH_CREDITNOTES_FAIL_ACTION =
  FETCH_CREDITNOTES_INIT_ACTION + "_FAIL";

export const FETCH_SUPPORTTICKETS_INIT_ACTION =
  "FETCH_SUPPORTTICKETS_INIT_ACTION";
export const FETCH_SUPPORTTICKETS_SUCCESS_ACTION =
  FETCH_SUPPORTTICKETS_INIT_ACTION + "_SUCCESS";
export const FETCH_SUPPORTTICKETS_FAIL_ACTION =
  FETCH_SUPPORTTICKETS_INIT_ACTION + "_FAIL";

export const FETCH_CANCELNORMALORDERS_INIT_ACTION =
  "FETCH_CANCELNORMALORDERS_INIT_ACTION";
export const FETCH_CANCELNORMALORDERS_SUCCESS_ACTION =
  FETCH_CANCELNORMALORDERS_INIT_ACTION + "_SUCCESS";
export const FETCH_CANCELNORMALORDERS_FAIL_ACTION =
  FETCH_CANCELNORMALORDERS_INIT_ACTION + "_FAIL";

export const FETCH_CANCELURGENTORDERS_INIT_ACTION =
  "FETCH_CANCELURGENTORDERS_INIT_ACTION";
export const FETCH_CANCELURGENTORDERS_SUCCESS_ACTION =
  FETCH_CANCELURGENTORDERS_INIT_ACTION + "_SUCCESS";
export const FETCH_CANCELURGENTORDERS_FAIL_ACTION =
  FETCH_CANCELURGENTORDERS_INIT_ACTION + "_FAIL";

export function fetchOrdersfromChemist() {
  return {
    type: FETCH_ORDERSFROMCHEMIST_INIT_ACTION
  };
}

export function processednormalOrdersList() {
  return {
    type: FETCH_NORMALPROCESSEDORDERS_INIT_ACTION
  };
}

export function deliverednormalOrdersList() {
  return {
    type: FETCH_DELIVEREDNORMALORDERS_INIT_ACTION
  };
}

export function cancellednormalOrdersList() {
  return {
    type: FETCH_CANCELNORMALORDERS_INIT_ACTION
  };
}

export function cancelledurgentOrdersList() {
  return {
    type: FETCH_CANCELURGENTORDERS_INIT_ACTION
  };
}

export function fetchUrgentOrders(value) {
  return {
    type: FETCH_URGENT_ORDERS_INIT_ACTION,
    value: value
  };
}

export function processedurgentOrdersList() {
  return {
    type: FETCH_PROCESSEDURGENTORDERS_INIT_ACTION
  };
}

export function deliveredurgentOrdersList() {
  return {
    type: FETCH_DELIVEREDURGENTORDERS_INIT_ACTION
  };
}

export function orderReturnList() {
  return {
    type: FETCH_RETURNS_INIT_ACTION
  };
}

export function fetchCreditNotes() {
  return {
    type: FETCH_CREDITNOTES_INIT_ACTION
  };
}

export function supportTickets() {
  return {
    type: FETCH_SUPPORTTICKETS_INIT_ACTION
  };
}

//For pagination of urgent orders table
export function pageSelected(value) {
  return {
    type: FETCH_URGENT_ORDERS_INIT_ACTION,
    value: value
  };
}
